import { useState, useMemo } from "react"
import { useQuery } from "react-query"
import usePlatform from "contexts/platform/use-platform"
import { ICompany } from "platform-client/types"

export const useGetCompanies: () => IUseGetCompanies = () => {
  const platform = usePlatform()
  const [companiesLoaded, setCompaniesLoaded] = useState<boolean>(false)

  const companiesQuery = useQuery<ICompany[]>(
    ["companies", "all"],
    () => platform.company.listCompanies(),
    {
      enabled: !!platform.token,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      onSuccess: () => {
        setCompaniesLoaded(true)
      }
    }
  )

  const companiesMap = useMemo(() => {
    if (!companiesQuery.data) return new Map<string, string>()
    const map = new Map<string, string>()
    companiesQuery.data.forEach((company) => {
      if (company && company.id && company.name) {
        map.set(company.id, company.name)
      }
    })
    return map
  }, [companiesQuery.data])

  return {
    companies: companiesQuery.data || [],
    companiesMap,
    isLoading: companiesQuery.isLoading || !companiesLoaded,
    companiesLoaded: companiesLoaded && !!companiesQuery.data
  }
}

interface IUseGetCompanies {
  companies: ICompany[]
  companiesMap: Map<string, string>
  isLoading: boolean
  companiesLoaded: boolean
}
